import { render, staticRenderFns } from "./SalesRanking.vue?vue&type=template&id=1abce982&scoped=true"
import script from "./SalesRanking.vue?vue&type=script&lang=js"
export * from "./SalesRanking.vue?vue&type=script&lang=js"
import style0 from "./SalesRanking.vue?vue&type=style&index=0&id=1abce982&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abce982",
  null
  
)

export default component.exports